import { render } from "./PaneListFractions.vue?vue&type=template&id=7255d6a6&scoped=true&ts=true"
import script from "./PaneListFractions.vue?vue&type=script&lang=ts"
export * from "./PaneListFractions.vue?vue&type=script&lang=ts"

import "./PaneListFractions.vue?vue&type=style&index=0&id=7255d6a6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7255d6a6"]])

export default __exports__